module.exports = __webpack_public_path__ + "static/img/feature_06.909f664.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/ares/secondAnniversary/3/feature_06.png
// module id = XWPD
// module chunks = 10